import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useCurrencySymbol } from '../../../../../utils/currencyUtils';
import CommaConvert from '../../../../../utils/CommaConvert';
import DateConversion from '../../../../../utils/DateConversion';
import { setCurrentPageTitle } from '../../../../../store/slices/pageSlice';
// import { useSnackbar } from 'notistack';
import { getAllAutoSaveWorkentries } from '../../../../../store/slices/autosaveSlice';
import { fetchHardware } from '../../../../../store/slices/hardwareSlice';
import { fetchWorkEntries } from '../../../../../store/slices/workentriesSlice';
import { fetchEmployees } from '../../../../../store/slices/employeeAdminSlice';
import { fetchHardwareDescriptions } from '../../../../../store/slices/hardwareDescriptionSlice';
import { fetchLeads } from '../../../../../store/slices/leadsSlice';
import { getAllAssemblyInventory } from '../../../../../store/slices/assemblyInventorySlice';
import { fetchAllProjects } from '../../../../../store/slices/projectsSlice';
import { fetchDescriptionTasks } from '../../../../../store/slices/descriptionTaskSlice';
import { fetchGroups } from '../../../../../store/slices/groupSlice';
// import { submitWorkEntries } from '../../../../../store/slices/submitTaskSlice';
// import { updateTaskStatus } from '../../../../../store/slices/projectTaskStatusSlice';
import { setPersonReadTrue } from '../../../../../store/slices/readSlice';
import AdminLoader from '../../../../../components/common/loader/AdminLoader';
import { MdSearch } from "react-icons/md";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
import "rc-slider/assets/index.css";
// import SubmitLoader from '../../../../../components/common/loader/SubmitLoader';
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import FileUploadOP from '../../../Operationperson/FileUploadOP';
import OPActionsPM from './OPActionsPM';

const OPProjectRequestedPM = ({ filterRequestProjects, handlerefresh, EmpEmail, isViewOnly = false }) => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const { formatDateByCountry } = DateConversion();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Operations Persons Dashboard"));
  }, [dispatch]);

  const [acceptedProject, setAcceptedProject] = useState("");
  // const emptyRow = React.useMemo(
  //   () => ({ task: "", hoursassigned: "", notes: "" }),
  //   []
  // );
  // const [trackedDebounceTimer, setTrackedDebounceTimer] = useState(null);
  const [, setFetchedHardwareData] = useState([]);
  const [initialEdit, ] = useState(false);
  // const [typingTimeout, setTypingTimeout] = React.useState(null);
  const { autosaveentries } = useSelector((state) => state.autosave);
  const [filteredEntries, setFilteredEntries] = useState([]);
  const [rows, setRows] = useState([]);
  const maintaskdivRef = useRef(null);
  // const installationtaskdiv = useRef(null);
  // const { enqueueSnackbar } = useSnackbar();
  const popupRef = useRef(null);

  const [showLogout, setshowlogout] = useState(false);
  const [showprojectDetails, SetShowprojectDetails] = useState(false);
  const [viewTaskSubmitted] = useState(false);
  const [, setSelectedApprovedTasks] = useState([]);
  const [, setFilterCompletedtask] = useState([]);
  const [taskToShow] = useState([]);
  const { completeTask } = useSelector((state) => state.completedTasks);
  const { personOngoingTasks } = useSelector(
    (state) => state.projectOngoingTasks
  );
  const { employees } = useSelector((state) => state.employees);
  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  // const [isLoadingtask, SetisLoadingtask] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [isLoading, SetisLoading] = useState(false);
  const [Action, setAction] = useState("task");
  const [hardwareAction, setHardwareAction] = useState();
  const [openDetailsIdx, setOpenDetailsIdx] = useState(null);
  const [triprows, setTripRows] = useState([
    { description: "", value: "", notes: "" },
  ]);
  const [totalDollerValue, settotalDollerValue] = useState(0);

  const [installation, setInstallation] = useState([]);
  const [tripduration, setTripDuration] = useState("");
  const [selectedproject, setselectedproject] = useState("");
  const [selectedprojectid, setselectedprojectid] = useState("");

  const [serviceofuser, setServiceofuser] = useState("task");
  const [Assignperson, setAssignperson] = useState("");
  const [hardware, setHardware] = useState([]);
  const { leads } = useSelector((state) => state.leads);
  const { projects } = useSelector((state) => state.projects);
  const LoggedUser = EmpEmail
  const currentEmployee = employees.find((emp) => emp.EmpEmail === LoggedUser);
  console.log("sfsgsdg", currentEmployee);
  const name = currentEmployee?.EmpFirstName;
  const lastName = currentEmployee?.EmpLastName;
  const AssignPerson = name + " " + lastName;

  useEffect(() => {
    const hasHardware = Array.isArray(acceptedProject.TypeService)
      ? acceptedProject.TypeService.some((service) =>
        service.includes("Hardware")
      )
      : acceptedProject.TypeService?.includes("Hardware");

    if (hasHardware) {
      setAction("");
      setHardwareAction("hardwarecost");
    } else {
      setAction("task");
      setHardwareAction("");
    }
  }, [acceptedProject?.TypeService]);

  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { inventory } = useSelector((state) => state.assemblyInventory);
  const { group: groups } = useSelector((state) => state.group);

  const groupNameById = useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = useCallback(
    (projectRow) => {
      if (typeof projectRow?.group === "string" && projectRow.group.trim()) {
        return projectRow.group;
      }

      const directGroupName =
        projectRow?.group?.newGroupName ||
        projectRow?.group?.groupname ||
        projectRow?.group?.groupName ||
        projectRow?.group?.name ||
        projectRow?.groupid?.newGroupName ||
        projectRow?.groupid?.groupname ||
        projectRow?.groupid?.groupName ||
        projectRow?.groupid?.name ||
        projectRow?.groupId?.newGroupName ||
        projectRow?.groupId?.groupname ||
        projectRow?.groupId?.groupName ||
        projectRow?.groupId?.name ||
        projectRow?.lead?.groupid?.newGroupName ||
        projectRow?.lead?.groupid?.groupname ||
        projectRow?.lead?.groupid?.groupName ||
        projectRow?.lead?.groupid?.name ||
        projectRow?.lead?.groupId?.newGroupName ||
        projectRow?.lead?.groupId?.groupname ||
        projectRow?.lead?.groupId?.groupName ||
        projectRow?.lead?.groupId?.name;

      if (directGroupName) return directGroupName;

      const groupId =
        projectRow?.group?._id ||
        projectRow?.group?.id ||
        projectRow?.group ||
        projectRow?.groupid?._id ||
        projectRow?.groupid?.id ||
        projectRow?.groupid ||
        projectRow?.groupId?._id ||
        projectRow?.groupId?.id ||
        projectRow?.groupId ||
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid?.id ||
        projectRow?.lead?.groupid ||
        projectRow?.lead?.groupId?._id ||
        projectRow?.lead?.groupId?.id ||
        projectRow?.lead?.groupId;

      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }

      // fallback for older API payloads
      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  useEffect(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
    dispatch(fetchWorkEntries());
    dispatch(fetchEmployees());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchLeads());
    dispatch(getAllAssemblyInventory());
    dispatch(fetchGroups());
  }, [dispatch]);

  // const handlerefreshagain = React.useCallback(() => {
  //   dispatch(getAllAutoSaveWorkentries());
  //   dispatch(fetchHardware());
  //   dispatch(fetchEmployees());
  //   dispatch(fetchHardwareDescriptions());
  //   dispatch(fetchLeads());
  //   dispatch(fetchAllProjects());
  //   dispatch(fetchDescriptionTasks());
  //   dispatch(getAllAssemblyInventory());
  // }, [dispatch]);

  useEffect(() => {
    if (acceptedProject && acceptedProject.Assignedperson) {
      const userEmail = LoggedUser // or whatever key you use to store email

      const assignedPerson = acceptedProject.Assignedperson.find(
        (person) => person.email === userEmail
      );
      setAssignperson(assignedPerson);
    }
  }, [acceptedProject, LoggedUser]);

  useEffect(() => {
    const userEmail = LoggedUser;
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);

    if (currentEmployee && items) {
      const filteredHardware = items?.filter(
        (item) =>
          item.taskownerid === currentEmployee?._id &&
          item.projectid === acceptedProject?._id
      );

      if (filteredHardware?.length) {
        setHardware(filteredHardware);
      } else {
        setHardware([
          {
            assemblepartdescription: "",
            partno: "",
            quantity: "",
            unitprice: "",
            totalprice: "",
          },
        ]);
      }
    }
  }, [items, acceptedProject, LoggedUser, employees]);

  useEffect(() => {
    if (!acceptedProject || !inventory || !employees) return;

    console.log("sdgsdgsd inventory", inventory);

    console.log("sdgsdgsd", acceptedProject);

    // Safely access the first element of AssignedManagerEmail array
    const userEmail =
      Array.isArray(acceptedProject?.AssignedManagerEmail) &&
        acceptedProject?.AssignedManagerEmail?.length > 0
        ? acceptedProject?.AssignedManagerEmail[0]
        : null;

    console.log("sdgsdgsd userEmail", userEmail);

    if (!userEmail) {
      setFetchedHardwareData([]);
      return;
    }

    const currentEmployee = employees?.find(
      (emp) => emp?.EmpEmail === userEmail
    );

    if (!currentEmployee) {
      setFetchedHardwareData([]);
      return;
    }

    const matchedtaskEntries = inventory?.filter(
      (entry) =>
        entry.group === acceptedProject?.AssignedGroup &&
        entry.createdBy === currentEmployee?._id
    );
    console.log("sdgsdgsd matchedtaskEntries", matchedtaskEntries);

    const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    }));

    setFetchedHardwareData(newhardwareRows);
  }, [inventory, acceptedProject, employees]);

  const [totalHoursAssigned, setTotalHoursAssigned] = useState(0);
  useEffect(() => {
    const total = filteredEntries.reduce((sum, entry) => {
      return sum + (parseFloat(entry.hoursassigned) || 0);
    }, 0);
    setTotalHoursAssigned(total);
  }, [filteredEntries]);

  // const handledirectSubmit = async () => {
  //   const email = localStorage.getItem("email");
  //   const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
  //   const projectid = selectedprojectid;
  //   const taskownerid = currentEmployee?._id;
  //   if (!projectid || !taskownerid) {
  //     return;
  //   }
  //   try {
  //     await dispatch(submitWorkEntries({ projectid, taskownerid }));
  //   } catch (error) {
  //     console.error("Failed to create task:", error);
  //   } finally {
  //     setselectedprojectid("");
  //   }
  // };

  useEffect(() => {
    const currentEmployee = employees.find((emp) => emp.EmpEmail === LoggedUser);
    const name = currentEmployee?.EmpFirstName;
    const lastName = currentEmployee?.EmpLastName;
    const AssignPerson = name + " " + lastName;
    const filteredProjects = projects.filter(
      (project) =>
        project.OperationStatus === "project Approved" &&
        project.Assignedperson?.some((person) => person.name === AssignPerson)
    );
    setSelectedApprovedTasks(filteredProjects);
  }, [projects, LoggedUser, employees]);

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchDescriptionTasks());
  }, [dispatch, AssignPerson]);

  useEffect(() => {
    const currentEmployee = employees.find((emp) => emp.EmpEmail === LoggedUser);
    const name = currentEmployee?.EmpFirstName;
    const lastName = currentEmployee?.EmpLastName;
    const AssignPerson = name + " " + lastName;
    if (Array.isArray(completeTask)) {
      const result = completeTask.filter(
        (task) => task.assignedPerson === AssignPerson
      );
      setFilterCompletedtask(result);
    }
  }, [completeTask, LoggedUser, employees]);

  const groupedOngoingArray = Object.values(
    personOngoingTasks.reduce((acc, task) => {
      const project = task.projectName;
      if (!acc[project]) {
        acc[project] = {
          projectName: project,
          TypeService: task.TypeService,
          tasks: [],
          totalHours: 0,
          totalHoursSpent: 0,
          validTaskCount: 0,
        };
      }
      acc[project].tasks.push(task);

      // Only consider tasks where 'hoursspent' exists and is not 0
      if (task.hoursspent != null && task.hoursspent !== 0) {
        acc[project].totalHours += task.hours || 0;
        acc[project].totalHoursSpent += task.hoursspent || 0;
        acc[project].validTaskCount += 1; // Count only valid tasks
      }

      return acc;
    }, {})
  );
  // Now calculate averageHours for each project
  groupedOngoingArray.forEach((group) => {
    const { totalHours, totalHoursSpent, validTaskCount } = group;

    if (totalHours > 0 && validTaskCount > 0) {
      group.averageHours =
        ((totalHoursSpent / totalHours) * 100) / validTaskCount;
    } else {
      group.averageHours = 0;
    }

    // Optional: Round to 2 decimal places
    group.averageHours = Number(group.averageHours.toFixed(2));

    // Clean up temp totals
    delete group.totalHours;
    delete group.totalHoursSpent;
    delete group.validTaskCount;
  });

  const dropdownRefsProbability = useRef([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex !== null &&
        dropdownRefsProbability.current[openProbabilityIndex] &&
        !dropdownRefsProbability.current[openProbabilityIndex].contains(
          event.target
        )
      ) {
        setOpenProbabilityIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProbabilityIndex]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  useEffect(() => {
    if (rows.length === 0) {
      setRows([{ task: "", hoursassigned: "", notes: "" }]);
    }
  }, [rows, setRows]);

  useEffect(() => {
    if (triprows.length === 0) {
      setTripRows([{ description: "", value: "", notes: "" }]);
    }
  }, [triprows, setRows]);

  // const handleInputChange = (index, event) => {
  //   const { name, value } = event.target;

  //   // Create a deep copy of the rows array
  //   const updatedRows = rows.map((row) => ({ ...row }));

  //   if (name === "hoursassigned") {
  //     // Only allow numbers and handle max value
  //     const numericValue =
  //       value === "" ? null : Number(value.replace(/\D/g, ""));
  //     if (numericValue !== null && numericValue > 112) return;
  //     updatedRows[index][name] = numericValue;
  //   } else if (name === "notes") {
  //     // Only allow letters and spaces, limit to 40 characters
  //     const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "").slice(0, 40);
  //     updatedRows[index][name] = filteredValue;
  //   } else if (name === "task") {
  //     // Only allow letters, numbers, and spaces
  //     const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
  //     updatedRows[index][name] = filteredValue;
  //   } else {
  //     updatedRows[index][name] = value;
  //   }

  //   setRows(updatedRows);
  // };

  // const handleAddRow = () => {
  //   if (rows.length < 15) {
  //     setRows([...rows, { ...emptyRow }]); // Spread the emptyRow to create a new object
  //   } else {
  //     enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
  //   }
  // };
  // const handleRemoveRow = (index) => {
  //   const updatedRows = rows.filter((_, i) => i !== index);
  //   setRows(updatedRows);
  //   const sum = updatedRows.reduce((acc, row) => {
  //     const hours = parseFloat(row.hoursassigned) || 0;
  //     return acc + hours;
  //   }, 0);

  //   setTotalHoursAssigned(sum);
  //   setTimeout(() => {
  //     handleCreateTask(updatedRows); // Pass the updated rows directly
  //   }, 2000);
  // };

  const [, setLoggedEmp] = useState(null);

  useEffect(() => {
    const loggedInUserEmail = LoggedUser
    const loggedInEmployee = employees.find(
      (emp) => emp.EmpEmail === loggedInUserEmail
    );
    setLoggedEmp(loggedInEmployee);
  }, [employees, LoggedUser]);
  const alertRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (alertRef.current && !alertRef.current.contains(event.target)) {
        setshowAlert(showAlert);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAlert]);

  // const [rowAdded, setRowAdded] = useState(false);

  // Track row additions
  // const handleAddRowTracked = () => {
  //   handleAddRow();
  //   setRowAdded(true);
  // };

  // const handleInputChangeTracked = (index, e) => {
  //   // First call the original handleInputChange
  //   handleInputChange(index, e);

  //   // Track initial edit state
  //   if (!initialEdit && rows[index].createdBy === undefined) {
  //     setInitialEdit(true);
  //   }

  //   // Clear any existing timer
  //   if (trackedDebounceTimer) {
  //     clearTimeout(trackedDebounceTimer);
  //   }
  //   const updatedRows = [...rows];

  //   if (e.target.name === "hoursassigned") {
  //     // Calculate the new total by replacing the old value in the row
  //     updatedRows[index].hoursassigned = e.target.value; // Keep as string if needed

  //     const sum = updatedRows.reduce((acc, row) => {
  //       const hours = parseFloat(row.hoursassigned) || 0;
  //       return acc + hours;
  //     }, 0);
  //     setTotalHoursAssigned(sum);
  //   }
  //   const timer = setTimeout(() => {
  //     handleCreateTask(updatedRows);
  //   }, 2000);

  //   setTrackedDebounceTimer(timer);
  //   // }
  // };

  // const handleCreateTask = React.useCallback(
  //   async (rowsToSubmit) => {
  //     const filteredRows = rowsToSubmit.filter((entry) => {
  //       return (
  //         (entry.task && entry.task.trim() !== "") ||
  //         (entry.hoursassigned &&
  //           entry.hoursassigned.toString().trim() !== "") ||
  //         (entry.notes && entry.notes.trim() !== "")
  //       );
  //     });
  //     const projectid = acceptedProject._id;
  //     const cleanedData = filteredRows.map((entry) => ({
  //       task: entry.task || "",
  //       hoursassigned: Number(entry.hoursassigned) || 0,
  //       notes: entry.notes || "",
  //     }));
  //     SetisLoadingtask(true);
  //     try {
  //       await dispatch(
  //         replaceAllWorkEntries({
  //           projectid: projectid,
  //           newEntries: cleanedData,
  //           tasktype: "self",
  //         })
  //       );
  //     } catch (error) {
  //       console.error("Failed to create task:", error);
  //     } finally {
  //       SetisLoadingtask(false);
  //       dispatch(getAllAutoSaveWorkentries());
  //     }
  //     dispatch(fetchAllProjects());
  //   },
  //   [acceptedProject, dispatch]
  // );

  // useEffect(() => {
  //   return () => {
  //     if (trackedDebounceTimer) {
  //       clearTimeout(trackedDebounceTimer);
  //     }
  //   };
  // }, [trackedDebounceTimer]);

  // const handleInstallationChange = (index, field, value) => {
  //   setInstallation((prev) => {
  //     const updated = [...prev];
  //     updated[index] = {
  //       ...updated[index],
  //       [field]: value,
  //     };

  //     // Calculate total inside setState to ensure we have latest data
  //     if (field === "value") {
  //       const total = updated.reduce((sum, row) => {
  //         return sum + (parseFloat(row.value) || 0);
  //       }, 0);
  //       settotalDollerValue(total);
  //     }
  //     return updated;
  //   });
  //   setRowAdded(true);
  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }
  //   const newTimeout = setTimeout(() => {
  //     // Use functional update to get the latest installation state
  //     setInstallation((latestInstallation) => {
  //       handleinstallationtaskSubmitauto(tripduration, latestInstallation);
  //       return latestInstallation; // Return unchanged since we're just using the value
  //     });
  //   }, 2000);

  //   setTypingTimeout(newTimeout);
  // };
  // const handletripdurationChange = (numericValue) => {
  //   setTripDuration(numericValue);

  //   setRowAdded(true);

  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }

  //   // Set a new timeout
  //   const newTimeout = setTimeout(() => {
  //     handleinstallationtaskSubmitauto(numericValue);
  //   }, 2000); // 2 seconds

  //   setTypingTimeout(newTimeout);
  // };

  // const handleinstallationtaskSubmitauto = React.useCallback(
  //   async (numericValue, installationData = null) => {
  //     // Use provided data or fall back to state
  //     const dataToSave = installationData || installation;
  //     const filteredRows = dataToSave.filter((row) => {
  //       return (
  //         (row.description && row.description.trim() !== "") ||
  //         (row.value && row.value.toString().trim() !== "") ||
  //         (row.notes && row.notes.trim() !== "")
  //       );
  //     });
  //     if (!numericValue && !filteredRows[0]?.tripduration) {
  //       return;
  //     }

  //     SetisLoadingtask(true);
  //     try {
  //       const projectID = acceptedProject._id;
  //       const formdata = filteredRows.map((row) => ({
  //         ...row,
  //         taskstatus: "submit",
  //         tripduration: numericValue || filteredRows[0]?.tripduration,
  //       }));

  //       await dispatch(
  //         replaceAllDescriptionTasks({
  //           projectid: projectID,
  //           tasktype: "self",
  //           entries: [...formdata],
  //         })
  //       );
  //     } catch (error) {
  //       console.error("Operation failed:", error);
  //     } finally {
  //       SetisLoadingtask(false);
  //       setRowAdded(false);
  //       setInitialEdit(false);
  //       dispatch(fetchDescriptionTasks());
  //       setTripDuration("");
  //       handlerefresh();
  //     }
  //   },
  //   [dispatch, acceptedProject, handlerefresh, installation]
  // );

  // const handleinstallationtaskSubmit = React.useCallback(
  //   async (numericValue) => {
  //     if (!numericValue && !installation[0]?.tripduration) {
  //       return;
  //     }
  //     SetisLoadingtask(true);
  //     try {
  //       const projectID = acceptedProject._id;
  //       const formdata = installation.map((row) => ({
  //         ...row,
  //         taskstatus: "submit",
  //         tripduration: numericValue || installation[0]?.tripduration,
  //       }));
  //       await dispatch(
  //         replaceAllDescriptionTasks({
  //           projectid: projectID,
  //           tasktype: "self",
  //           entries: [...formdata],
  //         })
  //       );
  //     } catch (error) {
  //       console.error("Operation failed:", error);
  //     } finally {
  //       SetisLoadingtask(false);
  //       setRowAdded(false);
  //       setInitialEdit(false);
  //       handlerefreshagain();
  //       handlerefresh();
  //       setselectedprojectid("");
  //     }
  //   },
  //   [dispatch, installation, handlerefresh, acceptedProject, handlerefreshagain]
  // );

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       installationtaskdiv.current &&
  //       !installationtaskdiv.current.contains(event.target)
  //     ) {
  //       if (rowAdded) {
  //         handleinstallationtaskSubmit();
  //       }
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [handleinstallationtaskSubmit, rowAdded]);

  // const validateDescriptionOrNotes = (value) => {
  //   return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  // };
  // const validateValue = (value) => {
  //   // Allow only numbers and decimal point
  //   return value
  //     .replace(/[^0-9.]/g, "")
  //     .replace(/^\./, "") // Remove leading decimal
  //     .replace(/\./, "x") // Replace first decimal
  //     .replace(/\./g, "") // Remove all other decimals
  //     .replace(/x/, "."); // Put back the first decimal
  // };
  // for softwware and cloud otherexpenses
  // const handletaskSubmit = React.useCallback(async () => {
  //   // const email = localStorage.getItem("email");

  //   const hasEmptyFields = triprows.some((row) => {
  //     return (
  //       !row.description?.trim() ||
  //       !row.notes?.trim() ||
  //       row.value === "" ||
  //       row.value === null ||
  //       row.value === undefined
  //     );
  //   });
  //   if (hasEmptyFields) {
  //     return;
  //   }
  //   SetisLoadingtask(true);
  //   try {
  //     const projectId = acceptedProject._id;

  //     const formdata = triprows.map((row) => ({
  //       ...row,
  //       taskstatus: "submit",
  //     }));
  //     await dispatch(
  //       replaceAllDescriptionTasks({
  //         projectid: projectId,
  //         tasktype: "self",
  //         entries: [...formdata],
  //       })
  //     );
  //   } catch (error) {
  //     console.error("Operation failed:", error);
  //   } finally {
  //     setRowAdded(false);
  //     setInitialEdit(false);
  //     SetisLoadingtask(false);
  //     handlerefreshagain();
  //     handlerefresh();
  //     setselectedprojectid("");
  //   }
  // }, [triprows, dispatch, acceptedProject, handlerefreshagain, handlerefresh]);

  // const handletaskSubmitAuto = React.useCallback(
  //   async (newRows) => {
  //     const filteredRows = newRows.filter((row) => {
  //       return (
  //         (row.description && row.description.trim() !== "") ||
  //         (row.value && row.value.toString().trim() !== "") ||
  //         (row.notes && row.notes.trim() !== "")
  //       );
  //     });
  //     SetisLoadingtask(true);
  //     try {
  //       const projectId = acceptedProject._id;

  //       const formdata = filteredRows.map((row) => ({
  //         ...row,
  //         taskstatus: "submit",
  //       }));
  //       await dispatch(
  //         replaceAllDescriptionTasks({
  //           projectid: projectId,
  //           tasktype: "self",
  //           entries: [...formdata],
  //         })
  //       );
  //     } catch (error) {
  //       console.error("Operation failed:", error);
  //     } finally {
  //       setRowAdded(false);
  //       setInitialEdit(false);
  //       SetisLoadingtask(false);
  //       dispatch(fetchDescriptionTasks());
  //     }
  //   },
  //   [dispatch, acceptedProject]
  // );

  // const handleInputChanged = (index, field, value) => {
  //   const newRows = [...triprows];
  //   newRows[index][field] = value;
  //   setTripRows(newRows);
  //   setInitialEdit(true);

  //   if (field === "value") {
  //     const total = newRows.reduce((sum, row) => {
  //       return sum + (parseFloat(row.value) || 0);
  //     }, 0);
  //     settotalDollerValue(total);
  //   }

  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }

  //   // Set a new timeout
  //   const newTimeout = setTimeout(() => {
  //     handletaskSubmitAuto(newRows);
  //   }, 2000); // 2 seconds

  //   setTypingTimeout(newTimeout);
  // };
  // const handleAddRows = () => {
  //   setRowAdded(true);
  //   if (triprows.length >= 15) return; // Maximum 15 rows
  //   setTripRows([...triprows, { description: "", value: "", notes: "" }]);
  // };
  // const handleRemoveRows = () => {
  //   // if (triprows.length <= 1) return; // Minimum 1 row
  //   const newRows = [...triprows];

  //   newRows.pop();
  //   const total = newRows.reduce((sum, row) => {
  //     return sum + (parseFloat(row.value) || 0);
  //   }, 0);

  //   settotalDollerValue(total);
  //   setTripRows(newRows);
  //   setRowAdded(true);
  //   setTimeout(() => {
  //     handletaskSubmitAuto(newRows); // Pass the updated rows directly
  //   }, 2000);
  // };

  useEffect(() => {
    const userEmail = LoggedUser; // Make sure you're storing the email with this key
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const employeeId = currentEmployee?._id;
    const matchedTasks = tasks.filter(
      (task) =>
        task.projectid === acceptedProject._id &&
        (employeeId ? task.taskownerid === employeeId : true)
    );

    if (matchedTasks.length) {
      setInstallation(matchedTasks);
      setTripDuration(matchedTasks[0]?.tripduration);
    } else {
      setInstallation([
        { description: `Airfare (${currency})`, value: "", notes: "" },
        {
          description: `Miscellaneous Install Items to buy (${currency})`,
          value: "",
          notes: "",
        },
        { description: `Car Rental (${currency})`, value: "", notes: "" },
        { description: `Car fuel (${currency})`, value: "", notes: "" },
        { description: `Lodging (${currency})`, value: "", notes: "" },
      ]);
    }
  }, [selectedproject, acceptedProject, LoggedUser, tasks, employees, currency]);

  const [, setLoggedEmpOP] = useState(null);
  useEffect(() => {
    // Get the logged-in user's email from localStorage
    const loggedInUserEmail = LoggedUser; // Assuming you store email as 'userEmail'

    if (selectedproject && tasks.length > 0 && loggedInUserEmail) {
      // Find the employee with matching email
      const loggedInEmployee = employees.find(
        (emp) => emp.EmpEmail === loggedInUserEmail
      );
      setLoggedEmpOP(loggedInEmployee);
      if (loggedInEmployee) {
        // First filter by projectname
        const matchedTasks = tasks.filter(
          (task) => task.projectid === acceptedProject._id
        );

        // Then filter tasks that were created by this employee
        const employeeSpecificTasks = matchedTasks.filter(
          (task) => task.taskownerid === loggedInEmployee._id
        );

        // Convert matched tasks into triprows format
        const newTripRows = employeeSpecificTasks.map((task) => ({
          description: task.description || "",
          value: task.value || "",
          notes: task.notes || "",
        }));
        const total = newTripRows.reduce((sum, row) => {
          return sum + (parseFloat(row.value) || 0);
        }, 0);
        settotalDollerValue(total);
        setTripRows(
          newTripRows.length > 0
            ? [...newTripRows]
            : [{ description: "", value: "", notes: "" }]
        );
        // setTripRows(newTripRows.length > 0 ? newTripRows : [{ description: "", value: "", notes: "" }]);
      }
    }
  }, [selectedproject, acceptedProject, LoggedUser, tasks, employees]);

  useEffect(() => {
    const userEmail = LoggedUser;
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    console.log("SDfsdfsdf currentEmployee", currentEmployee);
    console.log("SDfsdfsdf acceptedProject", acceptedProject);

    if (!currentEmployee) return;

    console.log("SDfsdfsdf autosaveentries", autosaveentries);
    console.log("SDfsdfsdf tasks", tasks);
    console.log("SDfsdfsdf items", items);

    const matchedtaskEntries = autosaveentries.filter(
      (entry) =>
        entry.projectid === acceptedProject._id &&
        entry.taskownerid === currentEmployee._id
    );
    const matchedexpensesEntries = tasks.filter(
      (entry) =>
        entry.projectid === acceptedProject._id &&
        entry.taskownerid === currentEmployee._id
    );

    const matchedhardwareEntries = items.filter(
      (entry) =>
        entry.projectid === acceptedProject._id &&
        entry.taskownerid === currentEmployee._id
    );


    console.log("SDfsdfsdf matchedtaskEntries", matchedtaskEntries);
    console.log("SDfsdfsdf matchedexpensesEntries", matchedexpensesEntries);
    console.log("SDfsdfsdf matchedhardwareEntries", matchedhardwareEntries);

    if (matchedtaskEntries.length) {
      setFilteredEntries(matchedtaskEntries);
    } else if (matchedexpensesEntries.length) {
      setFilteredEntries(matchedexpensesEntries);
    } else if (matchedhardwareEntries.length) {
      setFilteredEntries(matchedhardwareEntries);
    }

    if (!initialEdit) {
      if (matchedtaskEntries.length > 0) {
        setRows(matchedtaskEntries.map((entry) => ({ ...entry })));
      } else {
        setRows([{ task: "", hoursassigned: "", notes: "" }]);
      }
    }
  }, [
    autosaveentries,
    employees,
    acceptedProject._id,
    setRows,
    initialEdit,
    tasks,
    items,
    LoggedUser,
    acceptedProject
  ]);

  const [operationPersonProject, setOperationPersonProject] = useState([]);

  useEffect(() => {
    setOperationPersonProject(filterRequestProjects); // initial fill or refetch
  }, [filterRequestProjects]);

  const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // Track the current page

  const [itemsPerPage] = useState(10);

  const totalItems = operationPersonProject?.length;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  // Function to calculate the number of pages
  const totalPages = Math.ceil(operationPersonProject?.length / itemsPerPage);

  // Slice the filteredLeadReport based on the current page
  const currentData = operationPersonProject?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1);
  };

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = filterRequestProjects.filter((LeadReport) =>
      (getDisplayGroupName(LeadReport) || "")
        .toString()
        .trim()
        .toLowerCase()
        .includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setOperationPersonProject(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;

    // Create a deep copy of the current data to avoid mutating state directly
    const sorted = [...operationPersonProject];

    // Helper function for case-insensitive comparison
    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };

    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(a), getDisplayGroupName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(b), getDisplayGroupName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // No sorting needed
        break;
    }

    // Update the state with the sorted array
    setOperationPersonProject(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  // const handleAddinstallationrow = () => {
  //   setRowAdded(true);
  //   if (triprows.length >= 15) return; // Maximum 15 rows
  //   setInstallation([
  //     ...installation,
  //     { description: "", value: "", notes: "" },
  //   ]);
  // };

  // const handleRemoveinstallationrow = () => {
  //   // if (installation.length <= 1) return; // Minimum 1 row
  //   const newRows = [...installation];
  //   newRows.pop();
  //   const total = newRows.reduce((sum, row) => {
  //     return sum + (parseFloat(row.value) || 0);
  //   }, 0);
  //   settotalDollerValue(total);
  //   setInstallation(newRows);
  //   setRowAdded(true);
  //   setTimeout(() => {
  //     handleinstallationtaskSubmitauto(tripduration, newRows); // Pass the updated rows directly
  //   }, 2000);
  // };

  // const handleAddHardware = () => {
  //   setRowAdded(true);
  //   if (hardware.length < 15) {
  //     setHardware([
  //       ...hardware,
  //       {
  //         assemblepartdescription: "",
  //         partno: "",
  //         quantity: "",
  //         unitprice: "",
  //         totalprice: "",
  //       },
  //     ]);
  //     resetTypingTimeout();
  //   }
  // };

  // const handleRemoveHardware = () => {
  //   const newHardware = [...hardware];
  //   newHardware.pop();
  //   setHardware(newHardware);
  //   setTimeout(() => {
  //     handlehardCostsAutosaveByOP(newHardware); // Pass the updated rows directly
  //   }, 2000);
  //   setRowAdded(true);
  // };

  // const handlehardwareInputChange = (index, key, value) => {
  //   const updated = [...hardware];

  //   if (key === "assemblepartdescription") {
  //     const selectedPart = fetchedHardwareData.find(
  //       (item) => item.assemblepartdescription === value
  //     );

  //     if (selectedPart) {
  //       updated[index] = {
  //         ...updated[index],
  //         assemblepartdescription: selectedPart.assemblepartdescription,
  //         partno: selectedPart.partnumber,
  //         unitprice: selectedPart.unitprice.toString(),
  //         quantity: "", // Reset quantity to empty
  //         totalprice: "", // Reset total price since quantity is empty
  //       };
  //     } else {
  //       updated[index] = {
  //         ...updated[index],
  //         assemblepartdescription: value,
  //         partno: "",
  //         unitprice: "",
  //         quantity: "", // Reset quantity to empty
  //         totalprice: "", // Reset total price
  //       };
  //     }
  //   } else if (key === "quantity") {
  //     const quantity = Number(value);
  //     const unitprice = Number(updated[index].unitprice || 0);

  //     updated[index] = {
  //       ...updated[index],
  //       quantity: value,
  //       totalprice:
  //         !isNaN(quantity) && quantity !== 0
  //           ? (unitprice * quantity).toFixed(2)
  //           : "0.00",
  //     };
  //   } else {
  //     updated[index][key] = value;
  //   }

  //   setHardware(updated);

  //   // Clear existing timeout
  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }

  //   // Set new timeout for autosave
  //   const newTimeout = setTimeout(() => {
  //     handlehardCostsAutosaveByOP(updated);
  //   }, 3000); // 3 seconds delay

  //   setTypingTimeout(newTimeout);
  // };

  // const handlehardCostsAutosaveByOP = React.useCallback(
  //   async (updatedhardware) => {
  //     const transformHardwareData = (hardwareArray) => {
  //       return hardwareArray.map((item) => ({
  //         ...item,
  //         taskstatus: "autosubmit",
  //       }));
  //     };
  //     const transformedData = transformHardwareData(updatedhardware);
  //     const payload = {
  //       projectid: acceptedProject._id,
  //       tasktype: "self",
  //       tasks: transformedData,
  //     };
  //     SetisLoadingtask(true);
  //     try {
  //       await dispatch(replaceAllHardwareDescriptions(payload));
  //     } catch (error) {
  //       console.error("Error saving hardware data:", error);
  //     } finally {
  //       SetisLoadingtask(false);
  //       handlerefreshagain();
  //       handlerefresh();
  //     }
  //   },
  //   [
  //     acceptedProject,
  //     handlerefresh,
  //     SetisLoadingtask,
  //     dispatch,
  //     handlerefreshagain,
  //   ]
  // );

  // const handlehardCostsSubmitByOP = React.useCallback(async () => {
  //   const hasEmptyFields = hardware.some((item) => {
  //     return (
  //       !item.assemblepartdescription ||
  //       !item.partno ||
  //       !item.quantity ||
  //       !item.totalprice ||
  //       !item.unitprice
  //     );
  //   });

  //   if (hasEmptyFields) {
  //     return;
  //   }
  //   const transformHardwareData = (hardwareArray) => {
  //     return hardwareArray.map((item) => ({
  //       ...item,
  //       taskstatus: "submit",
  //     }));
  //   };

  //   const transformedData = transformHardwareData(hardware);

  //   const payload = {
  //     projectid: acceptedProject._id,
  //     tasktype: "self",
  //     tasks: transformedData,
  //   };
  //   SetisLoadingtask(true);
  //   try {
  //     await dispatch(replaceAllHardwareDescriptions(payload));
  //   } catch (error) {
  //     console.error("Error saving hardware data:", error);
  //   } finally {
  //     SetisLoadingtask(false);
  //     setselectedprojectid("");
  //   }
  // }, [hardware, acceptedProject, SetisLoadingtask, dispatch]);

  // const resetTypingTimeout = useCallback(() => {
  //   if (typingTimeout) {
  //     clearTimeout(typingTimeout);
  //   }
  //   const newTimeout = setTimeout(() => {
  //     handlehardCostsSubmitByOP();
  //   }, 3000);
  //   setTypingTimeout(newTimeout);
  // }, [typingTimeout, handlehardCostsSubmitByOP]);

  // const handleSelectOpen = () => {
  //   resetTypingTimeout();
  // };

  // const updatebyname = useCallback(async () => {
  //   const email = LoggedUser
  //   const updatedAssignedperson = (acceptedProject.Assignedperson || [])
  //     .filter((person) => person.email === email)
  //     .map((person) => ({
  //       email: person.email,
  //       name: person.name,
  //       taskStatus: "submit",
  //       isRead: true,
  //     }));
  //   const filteredEmployee = employees.find(
  //     (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
  //   );
  //   const selectedProjectId = acceptedProject?._id;
  //   const loggedInUserId = filteredEmployee?._id;
  //   SetisLoading(true);
  //   try {
  //     await dispatch(
  //       updateTaskStatus({
  //         projectid: selectedProjectId,
  //         userid: loggedInUserId,
  //       })
  //     );
  //   } catch (error) {
  //     console.error("Operation failed:", error);
  //   } finally {
  //     SetisLoading(false);
  //   }
  // }, [dispatch, acceptedProject, LoggedUser, employees]);

  // const handleAction = async () => {
  //   SetisLoading(true);

  //   try {
  //     const serviceType = acceptedProject?.TypeService?.toLowerCase();

  //     switch (true) {
  //       case serviceType.includes("installation"):
  //         await handledirectSubmit();
  //         await handleinstallationtaskSubmit(tripduration);
  //         await updatebyname();
  //         break;

  //       case serviceType.includes("hardware"):
  //         await handlehardCostsSubmitByOP();
  //         await handletaskSubmit();
  //         await updatebyname();
  //         break;

  //       case serviceType.includes("software"):
  //       case serviceType.includes("cloud"):
  //         await handledirectSubmit();
  //         await handletaskSubmit();
  //         await updatebyname();
  //         break;

  //       default:
  //         await handledirectSubmit();
  //         await handletaskSubmit();
  //         await handlehardCostsSubmitByOP();
  //         await handleinstallationtaskSubmit(tripduration);
  //         await updatebyname();
  //     }

  //     enqueueSnackbar("Response Submitted Successfully.", {
  //       variant: "success",
  //     });
  //   } catch (error) {
  //     console.error("fwef", error);
  //   } finally {
  //     SetisLoading(false);
  //     // setForwardAction("")
  //     handlerefresh();
  //   }
  // };

  const [selected, setSelected] = useState(false);
  const ProjectRequestRef = useRef(null);

  useEffect(() => {
    if (selected && ProjectRequestRef.current) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectRequestRef.current.scrollWidth;
      ProjectRequestRef.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [selected]);

  const handleProjectread = async (project) => {
    if (isViewOnly) return;
    const email = LoggedUser; // "yapew30764@miracle3.com"
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const isUserAssigned = project.Assignedperson?.find(
      (person) => person.email === email // replace with your actual logged user email variable
    );
    const projectId = project._id;
    const personId = currentEmployee._id;
    if (isUserAssigned?.isRead === false) {
      try {
        await dispatch(setPersonReadTrue({ projectId, personId }));
      } catch (error) {
        console.error("Failed to reject Project:", error);
      } finally {
        handlerefresh();
      }
    }
  };
  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
      <div className={` bg-[#f3f8f8] w-full`}>
        <div className=" relative">
          <div className="">
            <div className="w-full flex gap-2 min-h-[10rem]">
              <div className="w-full pt-2 rounded-lg min-h-full justify-center">
                <div className="flex justify-between items-center rounded-t bg-white py-2 pr-2">
                  <div className=" font-semibold text-md px-2">
                    Project Requested
                  </div>

                  <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                    <MdSearch className=" w-5 h-5 text-gray-500" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      placeholder="Search"
                      className="bg-[#e0e7ff] outline-none w-[80%]"
                    />
                  </div>
                </div>

                <div
                  ref={ProjectRequestRef}
                  className="flex  w-full overflow-auto bg-white"
                >
                  <div className="w-full">
                    <div className=" head sticky top-0 z-[1400] flex bg-[#E8E8E8]  text-xs justify-between rounded-t-lg font-semibold text-center">
                      <div className="h-14 w-16 flex-shrink-0 pl-3 flex justify-start items-center align-middle bg-[#E8E8E8] text-black">
                        Sr. No
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-between items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Group</p>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("AssignedGroup", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("AssignedGroup", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-between items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Project Name</p>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("ProjectName", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("ProjectName", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-between items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p className="text-start break-words whitespace-normal">
                          {" "}
                          Date <br /> Requested
                        </p>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("DateRequested", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("DateRequested", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-between items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p className="text-start">Due Date </p>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("ProjectDueDate", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("ProjectDueDate", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[11%] flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Attachments</p>
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Action</p>
                      </div>
                      {selectedprojectid && (
                        <div className="h-14 w-[30rem] bg-[#E8E8E8] text-black text-xs flex-shrink-0">
                          <div className="h-[50%] pt-1">TaskList</div>
                          <div className="h-[50%] w-full flex justify-center align-middle items-center">
                            {(Array.isArray(serviceofuser)
                              ? serviceofuser.some((service) =>
                                ["Installation", "Software", "Cloud"].some(
                                  (keyword) => service.includes(keyword)
                                )
                              )
                              : ["Installation", "Software", "Cloud"].some(
                                (keyword) => serviceofuser?.includes(keyword)
                              )) && (
                                <div className="flex w-full">
                                  <div
                                    onClick={() => setAction("task")}
                                    className={`cursor-pointer flex justify-center align-middle items-center w-[50%] py-1 px-2 ${Action === "task"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Effort Expenses
                                  </div>
                                  <div
                                    onClick={() => setAction("otherExpenses")}
                                    className={`cursor-pointer flex justify-center align-middle items-center w-[50%] py-1 px-2 ${Action === "otherExpenses"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Other Expenses
                                  </div>
                                </div>
                              )}

                            {(Array.isArray(serviceofuser)
                              ? serviceofuser.some((service) =>
                                ["Hardware"].some((keyword) =>
                                  service.includes(keyword)
                                )
                              )
                              : ["Hardware"].some((keyword) =>
                                serviceofuser?.includes(keyword)
                              )) && (
                                <div className="flex w-full bg-orange-300">
                                  <div
                                    onClick={() =>
                                      setHardwareAction("hardwarecost")
                                    }
                                    className={`cursor-pointer flex justify-center align-middle items-center w-[50%] py-1 px-2 ${hardwareAction === "hardwarecost"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Hardware Costs
                                  </div>
                                  <div
                                    onClick={() =>
                                      setHardwareAction("otherexpenses")
                                    }
                                    className={`cursor-pointer  flex justify-center align-middle items-center w-[50%] py-1 px-2 ${hardwareAction === "otherexpenses"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Other Expenses
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div
                      ref={maintaskdivRef}
                      className="min-h-[10rem] max-h-[34rem]"
                    >
                      {currentData?.map((project, index) => {
                        const isUserAssigned = project.Assignedperson?.find(
                          (person) => person.email === LoggedUser // replace with your actual logged user email variable
                        );
                        return (
                          <div
                            key={index}
                            className={`flex justify-between ${isUserAssigned?.isRead === false
                              ? "font-bold"
                              : ""
                              } text-center w-full  text-xs`}
                          >
                            <div className="w-16 flex-shrink-0 border-b pl-3 flex justify-start align-middle items-center">
                              {startIdx + index + 1}
                            </div>
                            <div className="w-[16.6%]  flex-shrink-0 border-b p-2 truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                              <p className="truncate ">
                                {getDisplayGroupName(project)}
                              </p>
                            </div>
                            <div className="bg  w-[16.6%]  flex-shrink-0 p-2 border-b truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                              <p className="break-words whitespace-normal text-start">
                                {project.ProjectName}
                              </p>
                            </div>
                            <div className="w-[16.6%]  flex-shrink-0 p-2 border-b truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                              <p className="truncate  text-center">
                                {formatDateByCountry(project.DateRequested)}
                              </p>
                            </div>
                            <div className="w-[16.6%] flex-shrink-0 p-2  border-b truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                              <p className="truncate text-center">
                                {(() => {
                                  const userEmail =
                                    LoggedUser
                                  const assignedPerson =
                                    project.Assignedperson.find(
                                      (person) => person.email === userEmail
                                    );
                                  return assignedPerson?.OpDueDate
                                    ? formatDateByCountry(
                                      assignedPerson.OpDueDate
                                    )
                                    : " ";
                                })()}
                              </p>
                            </div>
                            <div className="w-[11%]  flex-shrink-0 p-2 border-b truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                              <FileUploadOP
                                project={project}
                                leads={leads}
                                employees={employees}
                                isViewOnly={isViewOnly}
                              />
                            </div>
                            <div className="w-[16.6%]  flex-shrink-0  border-b flex justify-center align-middle items-center text-center text-xs ">
                              <OPActionsPM
                                EmpEmail={EmpEmail}
                                handleProjectread={handleProjectread}
                                setOpenDetailsIdx={setOpenDetailsIdx}
                                project={project}
                                index={index}
                                SetisLoading={SetisLoading}
                                SetShowprojectDetails={SetShowprojectDetails}
                                setselectedproject={setselectedproject}
                                setselectedprojectid={setselectedprojectid}
                                setAcceptedProject={setAcceptedProject}
                                setServiceofuser={setServiceofuser}
                                setAction={setAction}
                                setSelected={setSelected}
                                selected={selected}
                                employees={employees}
                                handlerefresh={handlerefresh}
                                showprojectDetails={showprojectDetails}
                                isViewOnly={isViewOnly}
                              />
                            </div>

                            {selectedprojectid && (
                              <div
                                className={` 
                                 w-[30rem] border-b text-xs flex-shrink-0 custom-scroll ${selectedprojectid === project._id
                                    ? "min-h-[20vh]"
                                    : ""
                                  }  max-h-[53vh] overflow-auto`}
                              >
                                {openDetailsIdx === index && (
                                  <div className="w-full">
                                    {(Action === "otherExpenses" ||
                                      hardwareAction === "otherexpenses") && (
                                        <>
                                          {(Array.isArray(
                                            acceptedProject.TypeService
                                          )
                                            ? acceptedProject.TypeService.some(
                                              (service) =>
                                                [
                                                  "Software",
                                                  "Cloud",
                                                  "Hardware",
                                                ].some((keyword) =>
                                                  service.includes(keyword)
                                                )
                                            )
                                            : [
                                              "Software",
                                              "Cloud",
                                              "Hardware",
                                            ].some((keyword) =>
                                              acceptedProject.TypeService?.includes(
                                                keyword
                                              )
                                            )) && (
                                              <div className=" maintaskdiv w-full bg-white">
                                                <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                                                  {/* Table Header */}
                                                  <div className="flex flex-col w-full">
                                                    <div className="w-full">
                                                      <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                          Sr. No
                                                        </div>
                                                        <div className="w-[40%] border p-2">
                                                          Description
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Amount ({currency})
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Notes
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="w-full">
                                                      <div className="head flex text-center text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                                                        <div className="w-[40%] border p-2">
                                                          Total
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          {USAComma(
                                                            totalDollerValue
                                                          )}
                                                        </div>
                                                        <div className="w-[25%] border p-2"></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="w-full">
                                                    {triprows.map((row, index) => (
                                                      <React.Fragment key={index}>
                                                        {Assignperson?.taskStatus ===
                                                          "submit" ? (
                                                          <div className="flex items-center text-center w-full text-xs">
                                                            <div className="w-full">
                                                              <div className="head flex">
                                                                <div className="w-[10%] border p-1">
                                                                  {index + 1}
                                                                </div>

                                                                <div className="w-[40%] border p-2">
                                                                  {row.description}
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  {USAComma(
                                                                    row.value
                                                                  )}
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  {row.notes}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <div className="flex items-center text-center w-full text-xs">
                                                            <div className="w-full">
                                                              <div className="head flex">
                                                                <div className="w-[10%] border p-1">
                                                                  {index + 1}
                                                                </div>

                                                                <div className="w-[40%] border p-2">
                                                                  <input
                                                                    type="text"
                                                                    name="description"
                                                                    value={
                                                                      row.description
                                                                    }
                                                                    readOnly={true}
                                                                    // onChange={(e) =>
                                                                    //   handleInputChanged(
                                                                    //     index,
                                                                    //     "description",
                                                                    //     validateDescriptionOrNotes(
                                                                    //       e.target
                                                                    //         .value
                                                                    //     )
                                                                    //   )
                                                                    // }
                                                                    className="outline-none border-none text-center w-full h-full"
                                                                  />
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  <input
                                                                    type="text"
                                                                    name="value"
                                                                    value={USAComma(
                                                                      row.value
                                                                    )}
                                                                      readOnly={true}
                                                                    // onChange={(e) =>
                                                                    //   handleInputChanged(
                                                                    //     index,
                                                                    //     "value",
                                                                    //     validateValue(
                                                                    //       e.target
                                                                    //         .value
                                                                    //     )
                                                                    //   )
                                                                    // }
                                                                    onKeyDown={(
                                                                      e
                                                                    ) => {
                                                                      if (
                                                                        [
                                                                          "e",
                                                                          "E",
                                                                          "+",
                                                                          "-",
                                                                        ].includes(
                                                                          e.key
                                                                        )
                                                                      ) {
                                                                        e.preventDefault();
                                                                      }
                                                                    }}
                                                                    className="outline-none border-none text-center w-full h-full"
                                                                  />
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  <input
                                                                    type="text"
                                                                    name="notes"
                                                                    value={
                                                                      row.notes
                                                                    }
                                                                      readOnly={true}
                                                                    // onChange={(e) =>
                                                                    //   handleInputChanged(
                                                                    //     index,
                                                                    //     "notes",
                                                                    //     validateDescriptionOrNotes(
                                                                    //       e.target
                                                                    //         .value
                                                                    //     )
                                                                    //   )
                                                                    // }
                                                                    className="outline-none border-none text-center w-full h-full"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}

                                                        {/* Add / Remove Buttons */}
                                                        {/* {index ===
                                                          triprows.length - 1 &&
                                                          (Assignperson?.taskStatus ===
                                                            "submit" ? (
                                                            <></>
                                                          ) : (
                                                            <div className="flex justify-between px-2 pt-1">
                                                              <button
                                                                className="shadow-xl rounded-md p-1 add-row-button"
                                                                onClick={
                                                                  handleAddRows
                                                                }
                                                                disabled={
                                                                  triprows.length >=
                                                                  15
                                                                }
                                                              >
                                                                <AddIcon />
                                                              </button>
                                                              <button
                                                                className="shadow-xl rounded-md p-1"
                                                                onClick={
                                                                  handleRemoveRows
                                                                }
                                                              >
                                                                <RemoveIcon />
                                                              </button>
                                                            </div>
                                                          ))} */}
                                                      </React.Fragment>
                                                    ))}
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                          {/* {acceptedProject.TypeService ===
                                                    "Installation" && */}
                                          {(Array.isArray(
                                            acceptedProject.TypeService
                                          )
                                            ? acceptedProject.TypeService.some(
                                              (service) =>
                                                service.includes("Installation")
                                            )
                                            : acceptedProject.TypeService?.includes(
                                              "Installation"
                                            )) &&
                                            Action === "otherExpenses" && (
                                              <div
                                                className=" maintaskdiv w-full bg-white"
                                              // ref={installationtaskdiv}
                                              >
                                                <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                                                  <div className="flex flex-col w-full">
                                                    <div className="w-full">
                                                      <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                        <div className="w-[50%] border p-2 font-semibold">
                                                          Trip Duration (Days)
                                                        </div>
                                                        <div className="w-[50%] border p-2">
                                                          {Assignperson?.taskStatus ===
                                                            "submit" ? (
                                                            <>{tripduration}</>
                                                          ) : (
                                                            <input
                                                              type="text"
                                                              value={tripduration}
                                                            readOnly={true}
                                                              // onChange={(e) => {
                                                              //   const numericValue =
                                                              //     e.target.value.replace(
                                                              //       /[^0-9]/g,
                                                              //       ""
                                                              //     );

                                                              //   handletripdurationChange(
                                                              //     numericValue
                                                              //   );
                                                              // }}
                                                              placeholder="Enter duration"
                                                              className="h-full w-full outline-none bg-[#1973eb]"
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="w-full">
                                                      <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                          Sr. No
                                                        </div>
                                                        <div className="w-[40%] border p-2">
                                                          Description
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Amount ({currency})
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Notes
                                                        </div>
                                                      </div>
                                                      <div className="head flex text-center text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                                                        <div className="w-[40%] border p-2">
                                                          Total
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          {USAComma(
                                                            totalDollerValue
                                                          )}
                                                        </div>
                                                        <div className="w-[25%] border p-2"></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="w-full">
                                                    {installation.map(
                                                      (row, index) => (
                                                        <React.Fragment
                                                          key={index}
                                                        >
                                                          {Assignperson?.taskStatus ===
                                                            "submit" ? (
                                                            <div className="flex items-center text-center w-full text-xs">
                                                              <div className="w-full">
                                                                <div className="head flex">
                                                                  <div className="w-[10%] border p-1">
                                                                    {index + 1}
                                                                  </div>
                                                                  <div className="w-[40%] border p-2">
                                                                    {
                                                                      row.description
                                                                    }
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    {USAComma(
                                                                      row.value
                                                                    )}
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    {row.notes}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <div className="flex items-center text-center w-full text-xs">
                                                              <div className="w-full">
                                                                <div className="head flex">
                                                                  <div className="w-[10%] border p-1">
                                                                    {index + 1}
                                                                  </div>
                                                                  <div className="w-[40%] border p-2">
                                                                    <input
                                                                      type="text"
                                                                      name="description"
                                                                      value={
                                                                        row.description
                                                                      }
                                                                      placeholder="Enter Value"
                                                                      onKeyDown={(
                                                                        e
                                                                      ) => {
                                                                        if (
                                                                          [
                                                                            "+",
                                                                            "-",
                                                                          ].includes(
                                                                            e.key
                                                                          )
                                                                        ) {
                                                                          e.preventDefault();
                                                                        }
                                                                      }}
                                                                        readOnly={true}
                                                                      // onChange={(
                                                                      //   e
                                                                      // ) => {
                                                                      //   const Value =
                                                                      //     e.target
                                                                      //       .value;
                                                                      //   handleInstallationChange(
                                                                      //     index,
                                                                      //     "description",
                                                                      //     Value
                                                                      //   );
                                                                      // }}
                                                                      className="outline-none border-none text-center w-full h-full"
                                                                    />
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    <input
                                                                      type="text"
                                                                      name="value"
                                                                      value={USAComma(
                                                                        row.value
                                                                      )}
                                                                      placeholder="Enter Value"
                                                                      onKeyDown={(
                                                                        e
                                                                      ) => {
                                                                        if (
                                                                          [
                                                                            "e",
                                                                            "E",
                                                                            "+",
                                                                            "-",
                                                                          ].includes(
                                                                            e.key
                                                                          )
                                                                        ) {
                                                                          e.preventDefault();
                                                                        }
                                                                      }}
                                                                        readOnly={true}
                                                                      // onChange={(
                                                                      //   e
                                                                      // ) => {
                                                                      //   const numericValue =
                                                                      //     e.target.value.replace(
                                                                      //       /[^0-9]/g,
                                                                      //       ""
                                                                      //     );

                                                                      //   handleInstallationChange(
                                                                      //     index,
                                                                      //     "value",
                                                                      //     numericValue
                                                                      //   );
                                                                      // }}
                                                                      className="outline-none border-none text-center w-full h-full"
                                                                    />
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    <input
                                                                      type="text"
                                                                      name="notes"
                                                                      value={
                                                                        row.notes
                                                                      }
                                                                      placeholder="Enter Notes"
                                                                        readOnly={true}
                                                                      // onChange={(
                                                                      //   e
                                                                      // ) => {
                                                                      //   const validValue =
                                                                      //     e.target.value.replace(
                                                                      //       /[^a-zA-Z0-9 ]/g, // Note the added space in the character class
                                                                      //       ""
                                                                      //     );
                                                                      //   handleInstallationChange(
                                                                      //     index,
                                                                      //     "notes",
                                                                      //     validValue
                                                                      //   );
                                                                      // }}
                                                                      className="outline-none border-none text-center w-full h-full"
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}

                                                          {/* {index ===
                                                            installation.length -
                                                            1 &&
                                                            (Assignperson?.taskStatus ===
                                                              "submit" ? (
                                                              <> </>
                                                            ) : (
                                                              <div className="flex justify-between px-2 pt-1">
                                                                <button
                                                                  className="shadow-xl rounded-md p-1"
                                                                  onClick={
                                                                    handleAddinstallationrow
                                                                  }
                                                                  disabled={
                                                                    triprows.length >=
                                                                    15
                                                                  }
                                                                >
                                                                  <AddIcon />
                                                                </button>
                                                                <button
                                                                  className="shadow-xl rounded-md p-1"
                                                                  onClick={
                                                                    handleRemoveinstallationrow
                                                                  }
                                                                >
                                                                  <RemoveIcon />
                                                                </button>
                                                              </div>
                                                            ))} */}
                                                        </React.Fragment>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </>
                                      )}

                                    {Action === "task" && (
                                      <div className="w-full bg-white rounded-lg justify-center pb-5">
                                        <div className="flex w-full">
                                          <div className="w-full">
                                            <div className="head flex w-full text-center bg-[#3b82f6] text-white text-xs">
                                              <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                Sr. No
                                              </div>
                                              <div className="w-[40%] border p-2">
                                                Task
                                              </div>
                                              <div className="w-[25%] border p-2">
                                                Hours
                                              </div>
                                              <div className="w-[25%] border p-2">
                                                Notes
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex text-center w-full text-xs">
                                          <div className="w-full">
                                            <div className="head flex">
                                              <div className="w-[10%] border p-1"></div>

                                              <div className="w-[40%] border p-2">
                                                Total
                                              </div>
                                              <div className="w-[25%] border p-2">
                                                {totalHoursAssigned}
                                              </div>
                                              <div className="w-[25%] border p-2"></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="w-full">
                                          {rows.map((row, index) => (
                                            <>
                                              {Assignperson?.taskStatus ===
                                                "submit" ? (
                                                <div
                                                  className="flex items-center text-center w-full text-xs"
                                                  key={index}
                                                >
                                                  <div className="w-full">
                                                    <div className="head flex">
                                                      <div className="w-[10%] border p-1">
                                                        {index + 1}
                                                      </div>
                                                      <div className="w-[40%] border p-2">
                                                        {row.task}
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        {row.hoursassigned}
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        {row.notes}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  className="flex items-center text-center w-full text-xs"
                                                  key={index}
                                                >
                                                  <div className="w-full">
                                                    <div className="head flex">
                                                      <div className="w-[10%] border p-1">
                                                        {index + 1}
                                                      </div>
                                                      <div className="w-[40%] border p-2">
                                                        <input
                                                          type="text"
                                                          name="task"
                                                          value={row.task}
                                                            readOnly={true}
                                                          // onChange={(e) =>
                                                          //   handleInputChangeTracked(
                                                          //     index,
                                                          //     e
                                                          //   )
                                                          // }
                                                          className="outline-none border-none text-center w-full h-full"
                                                        />
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        <input
                                                          type="text" // Changed from "number" to "text" for better control
                                                          name="hoursassigned"
                                                          value={
                                                            row.hoursassigned
                                                          }
                                                          onKeyDown={(e) => {
                                                            if (
                                                              [
                                                                "e",
                                                                "E",
                                                                "+",
                                                                "-",
                                                              ].includes(e.key)
                                                            ) {
                                                              e.preventDefault();
                                                            }
                                                          }}
                                                            readOnly={true}
                                                          // onChange={(e) =>
                                                          //   handleInputChangeTracked(
                                                          //     index,
                                                          //     e
                                                          //   )
                                                          // }
                                                          className="outline-none border-none text-center w-full h-full"
                                                        />
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        <input
                                                          type="text"
                                                          name="notes"
                                                          value={row.notes}
                                                            readOnly={true}
                                                          // onChange={(e) =>
                                                          //   handleInputChangeTracked(
                                                          //     index,
                                                          //     e
                                                          //   )
                                                          // }
                                                          className="outline-none border-none text-center w-full h-full"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}

                                              {/* {rowstatus !== "submit" && ( */}
                                              {/* {Assignperson?.taskStatus ===
                                                "submit" ? (
                                                <></>
                                              ) : (
                                                <div className="flex justify-between">
                                                  <div className="">
                                                    {index ===
                                                      rows.length - 1 && ( // Add button only for last row
                                                        <button
                                                          className=" shadow-xl rounded-md p-1 add-row-button"
                                                          onClick={
                                                            handleAddRowTracked
                                                          }
                                                        >
                                                          <AddIcon />
                                                        </button>
                                                      )}
                                                  </div>
                                                  <div className="">
                                                    {index ===
                                                      rows.length - 1 && ( // Add button only for last row
                                                        <button
                                                          className=" right-1 shadow-xl rounded-md p-1"
                                                          onClick={() =>
                                                            handleRemoveRow(index)
                                                          }
                                                        >
                                                          <RemoveIcon />
                                                        </button>
                                                      )}
                                                  </div>
                                                </div>
                                              )} */}
                                              {/* )} */}
                                            </>
                                          ))}
                                        </div>
                                      </div>
                                    )}

                                    {hardwareAction === "hardwarecost" && (
                                      <div className="mainhardwarekdiv w-full bg-white">
                                        <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                                          {/* Table Header */}
                                          <div className="flex flex-col w-full">
                                            <div className="w-full">
                                              <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                  Sr. No
                                                </div>
                                                <div className="w-60 border py-1 break-words">
                                                  Assembly/Part Description
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Part No
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Quantity
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Unit Cost ({currency})
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Total Cost ({currency})
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="w-full">
                                            {hardware?.map((row, index) => (
                                              <React.Fragment key={index}>
                                                  <div className="flex items-center text-center w-full text-xs">
                                                    <div className="w-full">
                                                      <div className="head flex">
                                                        <div className="w-[10%] border p-1">
                                                          {index + 1}
                                                        </div>

                                                        {/* Description Select */}
                                                        <div className="w-60 border p-1">
                                                          {
                                                            row.assemblepartdescription
                                                          }
                                                        </div>
                                                        {/* Part Number */}
                                                        <div className="w-[20%] border p-1">
                                                          {row.partno}
                                                        </div>

                                                        {/* Quantity Input */}
                                                        <div className="w-[20%] border p-1">
                                                          {row.quantity}
                                                        </div>

                                                        {/* Unit Price */}
                                                        <div className="w-[20%] border p-1">
                                                          {USAComma(
                                                            row.unitprice
                                                          )}
                                                        </div>

                                                        {/* Total Price */}
                                                        <div className="w-[20%] border p-1">
                                                          {USAComma(
                                                            row.totalprice
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                
                                              </React.Fragment>
                                            ))}

                                            {/* Add/Remove Buttons */}
                                            {/* {Assignperson?.taskStatus ===
                                              "submit" ? (
                                              <></>
                                            ) : (
                                              <div className="flex justify-between px-2 pt-1">
                                                <button
                                                  className="shadow-xl rounded-md p-1"
                                                  onClick={handleAddHardware}
                                                  disabled={
                                                    hardware.length >= 15
                                                  }
                                                >
                                                  <AddIcon />
                                                </button>
                                                <button
                                                  className="shadow-xl rounded-md p-1"
                                                  onClick={handleRemoveHardware}
                                                >
                                                  <RemoveIcon />
                                                </button>
                                              </div>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}

                      {currentData?.length === 0 && (
                        <div className="noDataAvailable p-2">
                          No Result Found
                        </div>
                      )}
                    </div>
                  </div>

                  {viewTaskSubmitted && (
                    <div className="w-[30rem]">
                      <div className="w-full bg-white rounded-lg h-full justify-center min-h-[60vh]  pb-5">
                        <div className="flex w-full">
                          <div className="w-full">
                            <div className="head flex text-center bg-[#E8E8E8] text-black text-xs">
                              <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                Sr. No
                              </div>
                              <div className="w-[40%] border p-2">Task</div>
                              <div className="w-[20%] border p-2">Hours</div>
                              <div className="w-[25%] border p-2">Notes</div>
                            </div>
                          </div>
                        </div>

                        <div className="w-full">
                          {taskToShow.map((row, index) => (
                            <>
                              <div
                                className="flex items-center text-center w-full text-xs"
                                key={index}
                              >
                                <div className="w-full">
                                  <div className="head flex">
                                    <div className="w-[10%] border p-1">
                                      {index + 1}
                                    </div>
                                    <div className="w-[40%] border p-2">
                                      {row.task}
                                    </div>
                                    <div className="w-[20%] border p-2">
                                      {row.hoursassigned}
                                    </div>
                                    <div className="w-[25%] border p-2">
                                      {row.notes}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {currentData?.length > 0 && (
                  <div className="pagination flex justify-between items-center bg-white rounded-b-md p-2 text-[12px]">
                    <div>
                      {totalItems > 0 ? (
                        <>
                          Showing {startIdx + 1} to{" "}
                          {Math.min(endIdx, totalItems)} of {totalItems} Entries
                        </>
                      ) : (
                        <>Showing 0 Entries</>
                      )}
                    </div>
                    {totalPages > 1 && (
                      <div>
                        <button
                          onClick={() => setCurrentPage(1)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === 1}
                          title="First Page"
                        >
                          <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === 1}
                        >
                          <ChevronRightIcon className="w-5 h-5 rotate-180" />

                          {/* Previous */}
                        </button>

                        {Array.from({ length: 3 }, (_, index) => {
                          // Calculate the page number for the current range
                          const pageNumber = currentPage - 1 + index;

                          // Ensure the pageNumber stays within bounds
                          if (pageNumber >= 1 && pageNumber <= totalPages) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                                  ? "bg-gray-300"
                                  : ""
                                  }`}
                              >
                                {pageNumber}
                              </button>
                            );
                          }

                          // Return null for out-of-bounds values
                          return null;
                        })}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === totalPages}
                        >
                          <ChevronRightIcon className="w-5 h-5" />
                          {/* Next */}
                        </button>

                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === totalPages}
                          title="Last Page"
                        >
                          <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>)
}

export default OPProjectRequestedPM